import React from 'react'
import CircularProgress from './CircularProgress'

export const buildReportProgressToastMessage = (percent: number, stage?: string) => {
  const normalizedPercent = Math.max(0, Math.min(100, Math.round(percent)))
  const stageLabel = stage?.trim() || 'Generating report PDF...'

  return (
    <div className='d-flex align-items-center gap-3'>
      <CircularProgress percent={normalizedPercent} />
      <div className='d-flex flex-column gap-1'>
        <div className='text-dark'>Generating report...</div>
        <div className='text-muted'>{stageLabel}</div>
      </div>
    </div>
  )
}
